import { render, staticRenderFns } from "./enterprises_data.vue?vue&type=template&id=2c1b8a2c&scoped=true&"
import script from "./enterprises_data.vue?vue&type=script&lang=js&"
export * from "./enterprises_data.vue?vue&type=script&lang=js&"
import style0 from "./enterprises_data.vue?vue&type=style&index=0&id=2c1b8a2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b8a2c",
  null
  
)

export default component.exports